export const Tiktok = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width={props.width || 20}
    height={props.height || 20}
    {...props}
  >
    <path d="M12.2 1.5h3a4.4 4.4 0 0 0 4.4 4.4v2.7a7.1 7.1 0 0 1-4.4-1.5v7.3a5.9 5.9 0 1 1-5.9-5.9v2.9a3 3 0 1 0 3 3V1.5z" />
  </svg>
)